export default __webpack_public_path__ + "static/media/HorseshoeWhite.7af429b3.svg";